import React, { Component } from 'react';

import CardGrid from '../components/CardGrid';
import PropTypes from 'prop-types';
import isPage from '../hoc/isPage';
import { AppContext } from '../context/AppContext';
import { isEmpty } from '../helpers';
//import DropDownContainer from '../components/DropDownContainer';
import { DropDownList } from "@progress/kendo-react-dropdowns";
//import queryString from "query-string";

//import { Link } from 'react-router-dom'
class VendorListing extends Component {


    static propTypes = {
        handleChooseVendor: PropTypes.func,
        orderType: PropTypes.string
    }
    constructor(props) {
        super(props);

        this.state = {
            vendors: [],
            orderType: this.props.orderType
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {

        if (nextProps.orderType !== prevState.orderType) {

            return {
                orderType: nextProps.orderType
            }
        }
        return null;
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.orderType !== this.state.orderType) {
            this.prepareForDataLoad();
        }

    }
    componentDidMount() {

        this.prepareForDataLoad();

    }

    prepareForDataLoad = () => {
        //let vendors;

        const { orgType, childDealerships } = this.context.state;
        //let { selectedSuggestedOrderOrg } = this.context.state;
        let selectedSuggestedOrderOrg = this.props.getFromSessionStorage("selectedSuggestedOrderOrg")

        // if no currently selected org, and we have a list of child dealerships, then just select the first dealership in the list
        if (isEmpty(selectedSuggestedOrderOrg) && !isEmpty(childDealerships)) {
            selectedSuggestedOrderOrg = childDealerships[0];
            //this.context.setState({ selectedSuggestedOrderOrg })

            this.props.saveToSessionStorage("selectedSuggestedOrderOrg", selectedSuggestedOrderOrg)
        }

        let apiUrl = '';

        if (orgType === "dealer") {
            apiUrl = "/api/portal/vendor/GetList?includeSuggestedOrdersStats=1";

        } else if (orgType === "dealergroup") {
            // get the selectedOrg

            if (selectedSuggestedOrderOrg) {
                apiUrl = `/api/portal/vendor/${selectedSuggestedOrderOrg.orgID}/GetList?includeSuggestedOrdersStats=1`;
            } else {
                apiUrl = "/api/portal/vendor/GetList?includeSuggestedOrdersStats=1";
            }
        }

        if (!isEmpty(apiUrl)) {

            apiUrl += "&orderType=" + this.state.orderType

            this.loadData(apiUrl);
        }
    }

    // given an array of vendor objects, add a link property to each vendor object that will link to a page for its suggested orders
    addLinksToSuggestedOrders = (vendors) => {

        const selectedSuggestedOrderOrg = this.props.getFromSessionStorage("selectedSuggestedOrderOrg");

        vendors.forEach(vendor => {
            //const { selectedSuggestedOrderOrg } = this.context.state;

            if (selectedSuggestedOrderOrg) {
                vendor.link = `/suggested-order/${encodeURIComponent(vendor.orgVendorID)}/type/${this.state.orderType}/suggestions?selectedOrgID=${selectedSuggestedOrderOrg.orgID}&vendorName=${vendor.vendorName}&orgName=${selectedSuggestedOrderOrg.orgName}`;
            } else {
                vendor.link = `/suggested-order/${encodeURIComponent(vendor.orgVendorID)}/type/${this.state.orderType}/suggestions?vendorName=${vendor.vendorName}`;
            }





        });
        return vendors;
    }

    loadData = (apiUrl) => {

        this.props.getData(apiUrl).then(response => {

            this.setState({
                vendors: this.addLinksToSuggestedOrders(response.data)
            });
        }).catch(error => {

            this.props.alert("error", this.props.returnLocalizedString("m0023"), this.props.returnLocalizedString("m0431"))

        });
    }

    handleChangeDealer = (e) => {

        const selectedOrg = e.target.value;

        // save this to session storage
        this.props.saveToSessionStorage('selectedSuggestedOrderOrg', selectedOrg);

        // this.context.setState({
        //     selectedSuggestedOrderOrg: selectedOrg
        // });

        // refresh list of vendors

        let apiUrl = `/api/portal/vendor/${selectedOrg.orgID}/GetList?includeSuggestedOrdersStats=1`;

        apiUrl += "&orderType=" + this.state.orderType

        this.loadData(apiUrl);

    }
    render() {

        //!DBTRANS! @m0023@ Error! !DEVNOTE! Action status
        //!DBTRANS! @m0431@ Unable to get the list of vendors for this dealer. Please try again. !DEVNOTE! Action status
        //!DBTRANS! @m0432@ Select a vendor to view its list of suggested items. !DEVNOTE! Action status
        //!DBTRANS! @m0433@ Dealer: !DEVNOTE! 
        //!DBTRANS! @m0434@ Loading data... !DEVNOTE! 
        //!DBTRANS! @m0435@ There are no vendors with suggested items. !DEVNOTE! Action status

        const { orgType } = this.context.state;
        let dealerPicker = <React.Fragment />

        const cardGrid = (
            <React.Fragment>
                <p className="bottom-margin-10">{this.props.returnLocalizedString("m0432")}</p>

                <CardGrid handleClick={this.props.handleChooseVendor} type="vendors" data={this.state.vendors} />
            </React.Fragment>)

        if (orgType === "dealergroup") {
            //debugger;
            let { childDealerships } = this.context.state;
            let selectedSuggestedOrderOrg = this.props.getFromSessionStorage("selectedSuggestedOrderOrg");


            if (isEmpty(selectedSuggestedOrderOrg) && !isEmpty(childDealerships)) {
                //debugger;
                selectedSuggestedOrderOrg = childDealerships[0];
            }

            dealerPicker = (
                <form className="bottom-margin-20" style={{ backgroundColor: 'white', width: '100%', padding: '20px' }}>
                    <div className="search-controls">

                        <label htmlFor="dealer" className="padding-right-10">{this.props.returnLocalizedString("m0433")}</label>
                        <DropDownList id="selectedDealer"
                            name="selectedDealer"
                            value={selectedSuggestedOrderOrg}
                            data={childDealerships}
                            textField="orgName"
                            dataItemKey="orgID"

                            onChange={this.handleChangeDealer}
                        />
                    </div></form>);

            if (this.context.state.loading > 0) {
                return (
                    <React.Fragment>
                        {dealerPicker}
                    <p>{this.props.returnLocalizedString("m0434")}</p>
                    </React.Fragment>
                );
            }
            else {
                return (
                    <React.Fragment>

                        {dealerPicker}
                        {
                            // if we've chosen a dealer but there are no vendors attached to it, then show a message stating as such
                            (isEmpty(this.state.vendors) && !isEmpty(selectedSuggestedOrderOrg)) &&
                            (<p>{this.props.returnLocalizedString("m0435")}</p>)}
                        {
                            // show the list of vendors if we have them
                            !isEmpty(this.state.vendors) && (
                                cardGrid
                            )}

                    </React.Fragment>
                );
            }
        }
        else
            if (orgType === "dealer") {
                if (this.context.state.loading > 0) {
                    return (
                        <React.Fragment>
                            {dealerPicker}
                            <p>{this.props.returnLocalizedString("m0434")}</p>
                        </React.Fragment>
                    );
                }
                else {
                    if (isEmpty(this.state.vendors)) {
                        return (
                            <React.Fragment>
                                {dealerPicker}
                                <p>{this.props.returnLocalizedString("m0435")}</p>
                            </React.Fragment>
                        );
                    }
                    else {
                        return (
                            <React.Fragment>
                                {dealerPicker}
                                {cardGrid}
                            </React.Fragment>
                        );
                    }
                }
            }
            else {
                return <React.Fragment />;
            }
    }
}
export default isPage(VendorListing);
VendorListing.contextType = AppContext;


// WEBPACK FOOTER //
// ./src/containers/VendorListing.js